<template>
  <main class="announcement-admin-page">
    <!-- Header Card -->
        <PageHeader icon="fas fa-bullhorn">
      <template #title>
        Pengumuman {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola informasi dan periode tayang pengumuman untuk klinik
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-if="btn"
                @click="$router.push('/announcements/add')">
                <i class="fas fa-plus"></i>
                <span>Buat Pengumuman</span>
              </b-button>
      </template>
    </PageHeader>

    <section class="announcement-admin-panel">
      <modern-filter-bar embedded single-line :show-timeseries="false"
        :search-text.sync="filter.title" search-placeholder="Cari judul pengumuman"
        @search-keyup="filterByTitle" />

      <div class="announcement-admin-table">
        <medhop-data-table summary-title="Daftar Pengumuman"
          hover
          :items="items"
          :fields="fields"
          responsive="sm"
          show-empty
          empty-text="Belum ada pengumuman">
          <template #table-colgroup="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'actions' ? '132px' : field.key === 'number' ? '64px' : '' }" />
          </template>
          <template #cell(title)="data">
            <div class="announcement-admin-primary-cell">
              <span class="announcement-admin-row-icon"><i class="fas fa-bullhorn"></i></span>
              <span>{{ data.value }}</span>
            </div>
          </template>
          <template #cell(announcement_category_name)="data">
            <span class="announcement-admin-badge">{{ data.value || 'Tanpa kategori' }}</span>
          </template>
          <template #cell(start_date)="data">
            <span class="announcement-admin-date"><i class="far fa-calendar-alt"></i>{{ data.value || '-' }}</span>
          </template>
          <template #cell(end_date)="data">
            <span class="announcement-admin-date"><i class="far fa-calendar-check"></i>{{ data.value || '-' }}</span>
          </template>
          <template #cell(actions)="data">
            <div class="announcement-admin-actions">
              <b-button
                size="sm"
                v-b-tooltip.hover
                title="Detail"
                class="announcement-admin-action announcement-admin-action--view"
                @click="$router.push({ path: '/announcements/detail/' + data.item.id })">
                <i class="fas fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                v-if="btn"
                v-b-tooltip.hover
                title="Edit"
                class="announcement-admin-action announcement-admin-action--edit"
                @click="$router.push({ path: '/announcements/edit/' + data.item.id })">
                <i class="fas fa-edit"></i>
              </b-button>
              <b-button
                size="sm"
                v-if="btn"
                v-b-tooltip.hover
                title="Hapus"
                class="announcement-admin-action announcement-admin-action--delete"
                @click="deleteData(data.item.id)">
                <i class="fas fa-trash"></i>
              </b-button>
            </div>
          </template>
        </medhop-data-table>
      </div>

      <footer v-if="items.length != 0" class="announcement-admin-footer">
        <medhop-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @page-click="pageOnClick" />
      </footer>
    </section>
  </main>
</template>

<script>

import { debouncer } from "@/core/modules/Helper.js"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  name: "List",

  data() {
    return {
      // Filter
      filter: {
        title: ''
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "title",
          label: "Judul",
          sortable: true,
        },
        {
          key: "announcement_category_name",
          label: "Kategori",
          sortable: true,
        },
        {
          key: "start_date",
          label: "Mulai ditampilkan",
          sortable: true,
        },
        {
          key: "end_date",
          label: "Berakhir ditampilkan",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // User Access
      btn: false,
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let filterParams = `&title=${this.filter.title}`
      let response = await module.paginate('announcements', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }

      this.items = response.data
    },

    filterByTitle() {
      debouncer(() => { this.currentPage = 1; this.pagination() }, 500)
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete('announcements/' + id)
      // If Deleted
      if (result) {
        this.pagination()
        this.$root.$emit("updateAnnouncements");
      }
    },

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "2302") {
          this.btn = true
        }
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Pengumuman" }])
    // Get Data
    this.pagination()
    this.setActiveButton()
  },

}

</script>

<style lang="scss" src="@/assets/sass/pages/_announcement-admin.scss"></style>
